import { NovatiqAuthorizationClient } from '@/_auth-client';
import { AUTHORIZATION_API_URL } from '@/_constants';
import { HttpContextToken, HttpInterceptorFn } from '@angular/common/http';
import { inject } from '@angular/core';
import { environment } from '@environments/environment';

/** When true on a request context, the auth interceptor skips the Authorization header. */
export const BYPASS_AUTH = new HttpContextToken<boolean>(() => false);

export const authInterceptor: HttpInterceptorFn = (req, next) => {
  if (req.context.get(BYPASS_AUTH)) {
    return next(req);
  }

  const authClient = inject(NovatiqAuthorizationClient);
  const token = canAddAuthorizationToken(authClient, req.url);
  if (!token) {
    return next(req);
  }

  return next(
    req.clone({
      headers: req.headers.append('Authorization', token)
    })
  );
};

function canAddAuthorizationToken(authClient: NovatiqAuthorizationClient, url: string): string | null {
  if (url !== environment.NovatiqAPIURL + AUTHORIZATION_API_URL.AUTH && !url.includes('.json')) {
    return authClient.accessToken;
  }
  return null;
}
